if (!process.env.VUE_APP_IS_WEB) {
  var ResolutionDB = require("../database/models/Resolution");
}
import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import MediaMW from "./Media";

import ResolutionORM from "@/store/orm-axios/models/Resolution";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll()
          .then(res => {
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams, relatedId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionDB()
          .query({
            where: {
              agency_id: agencyId,
              deleted: null,
              resolution_catalog_id: relatedId,
              parent_resolution_id: null,
            },
          })
          .query(qb => {
            // filter
            queryParams.filter.forEach(filter => {
              qb.where(filter.column, "LIKE", "%" + filter.value + "%");
            });
          })
          .orderBy(queryParams.sort.by, queryParams.sort.dir)
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
          })
          .then(res => {
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .QUERY_FETCH(agencyId, queryParams, relatedId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionDB({ id: id, deleted: null })
          .fetch({
            withRelated: [
              "media",
              {
                children_resolutions: query => {
                  query.where("deleted", null);
                },
              },
              "children_resolutions.media",
            ],
          })
          .then(res => {
            console.log("GET resolution: ", res.serialize());
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);

      delete itemPost["id"];

      return new Promise((resolve, reject) => {
        new ResolutionDB(itemPost)
          .save()
          .then(res => {
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new ResolutionDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new ResolutionDB(itemDelete)
          .save(null, { isDelete: true })
          .then(async res => {
            // TODO: FIXME: think/structure a functionality to do this kind of cascade/orphanRemoval from another/better place
            // delete orphan resolutions
            for (var childResolution of itemDelete.children_resolutions) {
              await this.DELETE(childResolution);
            }

            // delete orphan media files
            await new ResolutionDB({ id: item.id })
              .fetch({
                withRelated: ["media"],
              })
              .then(async res => {
                var mediaIds = [];
                var medias = res.serialize().media;
                medias.forEach(media => {
                  mediaIds.push(media.id);
                });

                await MediaMW.BULK_DELETE(mediaIds);
              })
              .catch(err => {
                console.error(err);
              });

            ResolutionORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  // CHILD RESOLUTIONS
  async POST_MULTIPLE_CHILD_RESOLUTIONS(childResolutions, parentResolution) {
    console.log("childResolutions", childResolutions);
    console.log("parentResolution", parentResolution);

    var data = [];
    var errors = [];

    for (const childResolution of childResolutions) {
      var defaultChildResolution = {
        parent_resolution_id: parentResolution.id,
        resolution_catalog_id: parentResolution.resolution_catalog_id,
        agency_id: parentResolution.agency_id,

        name: childResolution.name,
        slug: strings.get_slug(childResolution.name),
        description: childResolution.description,

        majority_id: parentResolution.majority_id,
        position: childResolution.position,
      };

      if (!process.env.VUE_APP_IS_WEB) {
        await new ResolutionDB(defaultChildResolution)
          .save()
          .then(res => {
            // console.log("res create child resolution", res);
            ResolutionORM.insertOrUpdate({
              data: res.serialize(),
            });
            data.push(res.serialize());
          })
          .catch(err => {
            console.log("error create child resolution", err);
            errors.push(err);
          });
      } else {
        // api call ..
        await ResolutionORM.api()
          .POST(defaultChildResolution)
          .then(res => {
            data.push(res.response.data);
          })
          .catch(err => {
            errors.push(err);
          });
      }
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve({
          status: "success",
          message: "The process completed successfully.",
          data: data,
        });
      } else {
        reject({
          status: "error",
          message: "There were some errors in the process.",
          errors: errors,
          data: data,
        });
      }
    });
  },
  UPDATE_RESOLUTION_WITH_MEDIA(resolution, children_resolutions, media) {
    // console.log("resolution: ", resolution);
    // console.log("media: ", media);
    let mediaIds = [];
    media.forEach(element => {
      if (element.label) {
        mediaIds.push({
          id: element.id,
          label: element.label,
          keyId: element.keyId ? element.keyId : null,
          resolution_id: element.resolution_id ? element.resolution_id : null,
        });
      } else {
        mediaIds.push({
          id: element.id,
          label: element.name,
          keyId: element.keyId ? element.keyId : null,
          resolution_id: element.resolution_id ? element.resolution_id : null,
        });
      }
    });
    // Set only media for the parent resolution
    resolution.media = media.filter(m => m.resolution_id == resolution.id);
    resolution["mediaArray"] = mediaIds;
    resolution["childrenResolutionArray"] = children_resolutions;
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .UPDATE_RESOLUTION_WITH_MEDIA(resolution)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CREATE_RESOLUTION_WITH_MEDIA(resolution, children_resolutions, media) {
    // console.log("resolution: ", resolution);
    // console.log("media: ", media);
    let mediaIds = [];
    media.forEach(element => {
      if (element.label) {
        mediaIds.push({
          id: element.id,
          label: element.label,
          keyId: element.keyId ? element.keyId : null,
        });
      } else {
        mediaIds.push({
          id: element.id,
          label: element.name,
          keyId: element.keyId ? element.keyId : null,
        });
      }
    });
    resolution["mediaArray"] = mediaIds;
    resolution["childrenResolutionArray"] = children_resolutions;
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        ResolutionORM.api()
          .CREATE_RESOLUTION_WITH_MEDIA(resolution)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
